<template>
  <div>
    <ModuleHeader>Ticket Promedio</ModuleHeader>
    <v-overlay :value="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col md="12" cols="12">
        <v-card>
          <v-card-text>
            <p class="text-subtitle-1">Filtros</p>
            <v-row>
              <v-col md="3" cols="12" class="input">
                <label>Fecha inicial</label>
                <Datepicker @input="getAperturas()" @selected="selectDate" :value="input_date.format('MM/DD/YYYY')">
                </Datepicker>
              </v-col>
              <v-col md="3" class="input">
                <label>Fecha final</label>
                <Datepicker @input="getAperturas()" @selected="selectDateFinal" :disabled-dates="disableDates"
                  :value="input_date_final.format('MM/DD/YYYY')"></Datepicker>
              </v-col>
              <v-col md="3" cols="12">
                <v-autocomplete @input="getAperturas()" label="Departamentos" v-model="selectDep" item-text="Nombre"
                  item-value="id" :items="departamentos"></v-autocomplete>
              </v-col>
              <v-col cols="1" md="3">
                <v-autocomplete label="Turno" v-model="selectTurno" item-value="Turno" item-text="Desc"
                  :items="turnosList">
                  <template v-slot:append-outer>
                    <v-btn @click="getAperturas()" small color="primary">Buscar turnos</v-btn>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col md="3" cols="12">
                <v-text-field v-model="input_folio" label="Folio de Venta"></v-text-field>
              </v-col>
              <v-col md="3" cols="12">
                <v-text-field v-model="input_orden" label="Numero de orden"></v-text-field>
              </v-col>
              <v-col md="12" cols="12">
                <v-btn depressed @click="cleanFilter()" color="error">
                  Restablecer Filtro
                </v-btn>
                <v-btn depressed @click="getVentas()" color="success">
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12">
        <v-card v-if="showEstad" class="pa-4">
          <v-card-title class="headline">Resumen</v-card-title>
          <v-card-text>
            <v-row justify="space-between">
              <v-col cols="12" sm="3">
                <v-sheet elevation="2" class="pa-4 text-center">
                  <div class="text-h5">
                    {{ $pgsHelper.formatNumber(ventas_comp.length) }}
                  </div>
                  <div class="caption">Ventas</div>
                </v-sheet>
              </v-col>

              <v-col cols="12" sm="3">
                <v-sheet elevation="2" class="pa-4 text-center">
                  <div class="text-h5">
                    $ {{ $pgsHelper.formatNumber(comp_resumen_data.total) }}
                  </div>
                  <div class="caption">Total MXN</div>
                </v-sheet>
              </v-col>

              <v-col cols="12" sm="3">
                <v-sheet elevation="2" class="pa-4 text-center">
                  <div class="text-h5">
                    {{
                      $pgsHelper.formatNumber(comp_resumen_data.totalComensales)
                    }}
                  </div>
                  <div class="caption">Personas</div>
                </v-sheet>
              </v-col>

              <v-col cols="12" sm="3">
                <v-sheet elevation="2" class="pa-4 text-center">
                  <div class="text-h5">
                    $
                    {{
                      $pgsHelper.formatNumber(comp_resumen_data.ticketpromedio)
                    }}
                  </div>
                  <div class="caption">Ticket Promedio</div>
                </v-sheet>
              </v-col>
            </v-row>
          </v-card-text>
          <v-simple-table>
            <thead>
              <tr>
                <th>Area</th>
                <th>Ventas</th>
                <th>Comensales</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(area,index) in comp_resumen_data.totalesArea">
                <tr :key="index">
                  <td>{{area.Nombre}}</td>
                  <td>{{area.Ventas}}</td>
                  <td>{{area.Comensales}}</td>
                  <td>${{$pgsHelper.formatNumber(area.Total)}}</td>
                </tr>
              </template>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-col>
      <v-col md="12" cols="12">
        <v-tabs v-model="tab">
          <v-tab>Listado de ventas</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card>
              <v-btn style="right: 0; position: absolute" color="green" dark
                @click="exportExcel()"><v-icon>mdi-file-excel-box</v-icon>
                Exportar a Excel
                <!-- <download-excel
                  type="xls"
                  name="Reporte Venta"
                  :data="excelData"
                >
                </download-excel> -->
              </v-btn>
              <v-card-text>
                <v-simple-table class="mt-4">
                  <thead>
                    <tr>
                      <th>Folio</th>
                      <th>Cliente</th>
                      <th>Alias de venta</th>
                      <th>Fecha</th>
                      <th>Caja</th>
                      <th>Cajero</th>
                      <th>Personas</th>
                      <th>Total</th>
                      <th>Cambio</th>
                      <th>Estatus</th>
                      <th>Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="ventas_comp.length == 0">
                      <td colspan="7">No se encontraron datos</td>
                    </tr>
                    <template v-for="(res, index) in ventas_comp">
                      <tr :key="index">
                        <td>{{ res.Folio }}</td>
                        <td>{{ res.Cliente.Nombre }}</td>
                        <td>{{ res.Cliente.Apodo }}</td>
                        <td>{{ res.fecha }}</td>
                        <td>
                          {{
                            $pgsHelper.getById(data_cajas, "id", res.Caja).Nomb
                          }}
                        </td>
                        <td>
                          {{
                            $pgsHelper.getById(cashiers, "Id", res.Cajero).Nomb
                          }}
                        </td>
                        <td>
                          <b>{{ res.Comensales }}</b>
                        </td>
                        <td>{{ $pgsHelper.formatNumber(res.Total) }} MXN</td>
                        <td>{{ $pgsHelper.formatNumber(res.Cambio.MXN) }}</td>
                        <td>
                          <b v-bind:class="{
                            'orange--text': res.Devos,
                            'green--text': !res.Devos,
                          }">{{ res.Devos ? "Devolución" : "Activo" }}</b>
                        </td>
                        <td>
                          <v-btn @click="showDetail(res)" color="green" small>
                            Detalles
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <modal v-model="showModal" :showFooter="false" title="Detalle de la venta">
      <resumenVenta :selectedRes="selectedRes" />
    </modal>
  </div>
</template>

<style scoped></style>

<script>
import "../../../assets/css/sideBar.css";
import Cliente from "../../../clases/Cliente.js";
import Modificadores from "../../../clases/Modificadores.js";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import modal from "../../MainComponents/modal.vue";
import resumenVenta from "../../MainComponents/resumenVenta.vue";
import TicketVenta from "../../../clases/TicketVenta.js";
import ticket from "../../../tickets/ticketReprint.vue";
import GenericExcelExporter from "../../../clases/ExcelMaker/GeneralExcel.js";
import Currencies from "../../../clases/Currencies";
export default {
  name: "ReporteVentas",
  components: {
    Datepicker,
    /*Select2,*/
    resumenVenta,
    modal,
  },
  props: ["hideMenu"],
  data() {
    return {
      contenedores: [],
      areas: [],
      familias: [],
      keyResume: 0,
      tab: null,
      selectTurno: "ALL",
      aperturas: [],
      input_orden: "",
      loadingData: false,
      showEstad: false,
      input_date: moment(),
      input_date_final: moment(),
      selectedRes: "",
      data_clientes: [],
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      showModal: false,
      formKey: 0,
      data_ventas: [],
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      data_cajas: [],
      reservations: [],
      cashiers: [],
      selectDep: "ALL",
      dataToTicket: {},
    };
  },
  computed: {
    excelDataFacturacion() {
      let tickets = [];
      this.ventas_comp.map(async (venta) => {
        if (venta.Total != 0) {
          if (
            !venta._ProdIdx.includes("MBS-Movimiento") &&
            !venta._ProdIdx.includes("-NMZKJ2fyTWAv4maSf9M") &&
            !venta._ProdIdx.includes("Monedero")
          ) {
            tickets.push({
              Folio: venta.Folio,
              Cliente: venta.Cliente.Nombre,
              Alias: venta.Cliente.Apodo,
              Fecha: venta.fecha,
              Total: venta.Total,
              Cambio: venta.Cambio.MXN,
            });
          }
        }
      });
      return tickets;
    },
    excelData() {
      let tickets = [];
      this.ventas_comp.map(async (venta) => {
        tickets.push({
          Folio: venta.Folio,
          Cliente: venta.Cliente.Nombre,
          Alias: venta.Cliente.Apodo,
          Comensales: Number(venta.Comensales),
          Fecha: venta.fecha,
          Total: Number(venta.Total),
          Cambio: Number(venta.Cambio.MXN),
        });
      });
      return tickets;
    },
    turnosList() {
      let dep = [
        {
          Turno: "ALL",
          Desc: "Todos",
          CajeroName: "Todos",
        },
      ];
      this.aperturas.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    getPayMethods() {
      const pagos = {};

      this.$store.getters.getPDVPagosTipos.forEach((pago) => {
        if (pago.Moneda == "All") {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            pagos[pago.id + "_" + tipo.id] = {
              id: pago.id + "_" + tipo.id,
              Nombre: pago.Nombre + " " + tipo.Nombre,
            };
          });
        } else if (pago.Moneda == "None") {
          pagos[pago.id] = { id: pago.id, Nombre: pago.Nombre };
        } else {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            if (tipo.id == pago.Moneda) {
              pagos[pago.id + "_" + tipo.id] = {
                id: pago.id + "_" + tipo.id,
                Nombre: pago.Nombre + " " + tipo.Nombre,
              };
            }
          });
        }
      });

      return pagos;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    ventas_comp() {
      this.data_ventas.forEach((venta) => {
        if (!venta.Comensales) {
          venta.Comensales = 1;
        }
        let totales = 0;
        for (const property in venta.Catalogo) {
          let totalProd = 0;
          if (venta.Catalogo[property].Modificadores) {
            venta.Catalogo[property].ModificadoresList =
              Modificadores.parseToListOption(
                venta.Catalogo[property].Modificadores
              );
            let totalModi = 0;
            venta.Catalogo[property].ModificadoresList.forEach((modi) => {
              totalModi += modi.pco.C;
            });
            venta.Catalogo[property].totalModi = totalModi;
          }
          if (venta.Catalogo[property].Pagos) {
            Object.entries(venta.Catalogo[property].Pagos).forEach((pago) => {
              totales += pago[1].def.C;
              if (new moment(venta.FechaCreacion).format("YYYY") == "2023") {
                if (venta.Catalogo[property].STip == "Cuenta") {
                  pago[1].def.C = pago[1].def.C + pago[1].dsc.C * -1;
                  pago[1].dsc.C = 0;
                  venta.Catalogo[property].Descuentos = [];
                }
              }
              totalProd += pago[1].def.C;
            });
          }
          venta.Catalogo[property].TotalReal = Number(totalProd);
        }

        venta.sumatoriaTotal = totales;
      });
      let data = this.data_ventas;
      let array = data.sort(function (a, b) {
        if (b.Folio > a.Folio) return -1;
        if (b.Folio < a.Folio) return 1;
      });
      return array;
    },
    selectedReserva() {
      return this.selectedRes;
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    comp_resumen_data() {
      let total_products = 0;
      let total_golf_round = 0;
      let total_proshop = 0;
      let total = 0;
      let totalComensales = 0;
      let totalesArea = {}
      this.data_ventas.forEach((venta) => {
        if (!venta.Comensales) {
          venta.Comensales = 1;
        }
        totalComensales += venta.Comensales;
        let prod = Object.entries(venta.Catalogo);
        this.$pgsHelper.log(prod);
        prod.forEach((producto) => {
          if (producto[0] == "Golf_Round") {
            total_golf_round++;
          } else {
            total_proshop++;
          }
          total_products++;
        });
        total = total + parseInt(venta.Total);
        let mesa = null
        venta.Catalogo.forEach((producto) => {
          if (producto.ExtraParams?.AYB?.Mesa) {
            mesa = producto.ExtraParams?.AYB?.Mesa
          }
        })

        if (mesa) {
          let mesaData = this.$pgsHelper.getById(this.contenedores, "id", mesa)
          console.log(mesaData)
          if (mesaData) {
            let area = this.$pgsHelper.getById(this.areas, "id", mesaData.Area)
            if (area) {
              if (!totalesArea[area.id]) {
                totalesArea[area.id] = {
                  Nombre: area.Nombre,
                  Total: 0,
                  Ventas: 0,
                  Comensales: 0,
                }
              }
              totalesArea[area.id].Total += venta.Total
              totalesArea[area.id].Comensales += venta.Comensales
              totalesArea[area.id].Ventas++
            }
          }
        } else {
          if (!totalesArea["VentaRapida"]) {
            totalesArea["VentaRapida"] = {
              Nombre: "Venta Rapida",
              Total: 0,
              Ventas: 0,
              Comensales: 0,
            }

          }
          totalesArea["VentaRapida"].Total += venta.Total
          totalesArea["VentaRapida"].Comensales += venta.Comensales
          totalesArea["VentaRapida"].Ventas++
        }
      });
      let areas = this.$pgsHelper.ArrayObjectToArray(totalesArea)
      areas.sort((a,b)=>{
        return b.Comensales - a.Comensales
      })
      return {
        total_productos: total_products,
        total_rounds: total_golf_round,
        total_proshop: total_proshop,
        totalComensales: totalComensales,
        totalesArea: areas,
        total: total,
        ticketpromedio:
          totalComensales > 0 ? Number(total) / Number(totalComensales) : 0,
      };
    },
    comp_clients() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((cli) => {
        clientes.push({ value: cli.Id, text: cli.getNombreCompleto() });
      });
      return clientes;
    },
  },
  methods: {
    exportExcel() {
      GenericExcelExporter.generateExcelBuffer(this.excelData)
        .then(buffer => {
          const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = "Valoracion de inventario.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(error => console.error("Error exportando:", error));
    },
    async printMasiveTicket(ticketHtml) {
      let html = "";
      let cssTicket = await this.$pgsHelper.getTicketCss();
      setTimeout(async () => {
        html += "<html><head><title>" + document.title + "</title>";
        html += "<style>" + cssTicket + "</style>";
        html += "</head><body >";

        html += ticketHtml;
        html += "</body></html>";
        this.$pgsHelper.printTicket(this, html);
      }, 2000);
    },
    async getTipoCambio(id) {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const doc = firestore.doc("PDV_TipoCambio", id);

      const tc = await firestore.getDoc(doc);
      let tcdoc = { Id: tc.ref.id, ...tc.data() };
      return tcdoc;
    },
    async printTicket(res, sinPrecio = false) {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/CONF/" + res.Departamento
        );
      let resultConf = data.val();
      let cssTicket = await this.$pgsHelper.getTicketCss();
      let tipoCambio = await this.getTipoCambio(res.TipoCambio);
      res.TC = tipoCambio.TC;
      this.dataToTicket = res;
      let Cajero = this.$pgsHelper.getById(this.cashiers, "Id", res.Cajero);
      this.dataToTicket.cajero = { NombreCajero: Cajero.Nomb || "Sin Cajero" };
      this.dataToTicket.sinPrecio = sinPrecio;
      this.dataToTicket.Depto = resultConf;
      let ticketHtml = this.$pgsHelper.getHtmlFromComponent(this, ticket, {
        dataToTicket: this.dataToTicket, currenciDefault: Currencies.getCurrencyDefault()
      });
      let html = "";
      //let stylesHtml = "";
      setTimeout(async () => {
        /*for (const node of [
          ...document.querySelectorAll('link[rel="stylesheet"], style'),
        ]) {
          stylesHtml += node.outerHTML;
        }*/

        html += "<html><head><title>" + document.title + "</title>";
        html += "<style>" + cssTicket + "</style>";
        //html+= stylesHtml
        html += "</head><body >";

        html += ticketHtml;
        html += "</body></html>";
        /* if (this.$pgsHelper.getConfig("useServerPrinter")) {
          this.$pgsHelper.printerInServerPrinter(
            "<body>" + ticketHtml + "</body>",
            "<style>" + cssTicket + "</style>",
            "TICKET-PRINTER"
          );
        } else {*/
        /*let defaultPreviousPrinter = await this.$pgsHelper.getDefaultPrinter(
            this
          );
          let printer = this.$pgsHelper.getPrinter("tickets");
          if (printer != false) {
            await this.$pgsHelper.usePrinter(printer);
          }*/
        this.$pgsHelper.printTicket(this, html);
        /* }*/
        //this.$pgsHelper.printTicket(this, html,defaultPreviousPrinter);
      }, 2000);
    },
    async getAperturas() {
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("Momento", ">=", startDate),
        firestore.where("Momento", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        //firestore.where("Caja", "==", this.$route.params.idInstalacion),
        firestore.where("Tipo", "==", "Apertura"),
      ];
      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(
          firestore.where("Departamentos", "array-contains", this.selectDep)
        );
      }

      const data = await firestore.queryBuilder("PDV_CierreApertura", filter);
      //
      let aperturas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      aperturas.forEach((apt) => {
        let fecha = new moment(apt.Momento, "YYYY-MM-DD_HH:mm:ss");
        let caja = this.$pgsHelper.getById(this.data_cajas, "id", apt.Caja);
        let cajeroData = this.$pgsHelper.getById(
          this.cajeros,
          "Id",
          apt.Cajero
        );
        apt.CajaData = caja;
        apt.CajeroData = cajeroData;
        apt.CajeroName = cajeroData.Nomb;
        apt.Desc =
          "Turno Fecha " +
          fecha.format("DD-MM-YYYY") +
          " Hora: " +
          fecha.format("HH:mm") +
          " || " +
          caja.Nomb +
          " || Turno: " +
          apt.Turno;
      });

      this.aperturas = aperturas;
    },
    cleanFilter() {
      (this.input_date = moment()),
        (this.input_date_final = moment()),
        (this.input_folio = "");
      this.selectClient = "";
      this.input_orden = "";
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = prod;
        let pag = Object.entries(this.selectedRes.Pagos);
        this.selectedRes.ListPagos = pag;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    async getCajas() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajas"
        );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getCashiers() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros"
        );

      if (snapshot.exists()) {
        this.cashiers = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cashiers.push(toAdd);
          }
        });
      }
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getVentas() {
      this.loadingData = true;

      let turnos = [];
      if (this.selectTurno != "ALL") {
        turnos.push(this.selectTurno);
      } else {
        this.aperturas.forEach((de) => {
          turnos.push(de.Turno);
        });
      }
      let arrayFilter = this.pagos;
      if (this.transaccion) {
        arrayFilter = arrayFilter.map((pago) => {
          return pago + "-" + this.transaccion;
        });
      }
      let listVentas = [];
      let data_ventas = [];
      if (this.input_folio != "") {
        const firestore = this.$store.getters.getFirebaseApp.firestore;

        let filter = [
          firestore.where("Folio", "==", this.input_folio),
          firestore.where(
            "Tenant",
            "==",
            this.$store.getters.getFirebaseApp.tenant
          ),
        ];
        const data = await firestore.queryBuilder("PDV_Ventas", filter);
        let preData = [];
        preData = data.docs.map((doc) => {
          listVentas.push({ id: doc.ref.id, ...doc.data() });
          return { id: doc.ref.id, ...doc.data() };
        });
        data_ventas = listVentas;
      } else {
        let taskTurnos = turnos.map(async (id) => {
          const firestore = this.$store.getters.getFirebaseApp.firestore;
          let filter = [
            firestore.where("Turno", "==", id),

            firestore.where(
              "Tenant",
              "==",
              this.$store.getters.getFirebaseApp.tenant
            ),
          ];

          if (this.selectDep != "ALL" && this.selectDep != "") {
            filter.push(firestore.where("Departamento", "==", this.selectDep));
          }
          /*if (arrayFilter.length > 0) {
        filter.push(
          firestore.where("_PagoIdx", "array-contains-any", arrayFilter)
        );
      }*/

          if (this.input_folio != "") {
            filter.push(firestore.where("Folio", "==", this.input_folio));
          }

          if (this.input_orden != "") {
            filter.push(firestore.where("Orden", "==", this.input_orden));
          }

          if (this.selectClient != "") {
            filter.push(firestore.where("Cliente.Id", "==", this.selectClient));
          }

          const data = await firestore.queryBuilder("PDV_Ventas", filter);
          let preData = [];
          preData = data.docs.map((doc) => {
            listVentas.push({ id: doc.ref.id, ...doc.data() });
            return { id: doc.ref.id, ...doc.data() };
          });
        });

        await Promise.all(taskTurnos).then((turnos) => {
          data_ventas = listVentas;
        });
      }

      data_ventas.forEach((item) => {
        item.fecha = new moment(item.FechaCreacion).format("YYYY-MM-DD HH:mm");
        item.Catalogo.forEach((prod) => {
          prod.ivaPercent = this.$pgsHelper.getIvaByFamilia(
            this.familias,
            prod.Familia.I
          );
        });
      });
      this.data_ventas = this.$_.orderBy(data_ventas, "fecha", "desc");
      this.showEstad = true;
      this.loadingData = false;
      this.keyResume++;
    },
    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );

      this.familias = [];
      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getContenedores() {
      let mesas = [];
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Contenedores"
        );
      if (data.exists()) {
        const dataContenedores = Object.entries(data.val());
        dataContenedores.forEach((mapa) => {
          const contenedores = this.$pgsHelper.ArrayObjectToArray(mapa[1]);
          contenedores.forEach((mesa) => {
            mesas.push(mesa);
          });
        });
      }
      this.contenedores = mesas;
    },
    async getAreas() {
      let areasList = [];
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Areas"
        );
      if (data.exists()) {
        const dataAreas = Object.entries(data.val());
        dataAreas.forEach((mapa) => {
          const areas = this.$pgsHelper.ArrayObjectToArray(mapa[1]);
          areas.forEach((mesa) => {
            areasList.push(mesa);
          });
        });
      }
      this.areas = areasList;
    },
  },
  beforeCreate: function () { },
  beforeMount: async function () {
    await this.getAperturas();
    await this.getFamilias();
    this.getVentas();
    this.getCajas();
    this.getCashiers();
    this.getAreas()
    this.getContenedores()
    this.$emit("useNav", true);
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
